import React from 'react';
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container, Dropdown } from "react-bootstrap";

import BaseActionForm from '../BaseActionForm';
import DatasetUtils from "../../services/DatasetUtils";

import ImportDataset from '../ImportDataset';
import Connector from '../Connector';
import Decomposer from '../Decomposer';
import Normaliser from '../Normaliser';
import GeometryTransformer from '../GeometryTransformer';
import Publisher from '../Publisher';
import Tarifs from '../Tarifs';

import { selectDataset, openLeftPanel, updateMyDatasets } from "./../../services/StoreContainer/actionCreators";
import * as actionTypes from "./../../services/StoreContainer/actionTypes";
import { checkActiveProcess } from '../../utils/ProcessFunctions.js';
import { prettyDateTime } from "../../utils/DateFunctions.js"

import "./styles.scss"
import Arrow from "../../assets/Arrow.svg"
import Filter_A_Z from "../../assets/Filter_AZ.svg"
// import FindIcon from "../../assets/FindIcon.svg"
import DataIcon from "../../assets/datainfo_icon.svg"
import MenuIcon from "../../assets/menudots_icon.svg"
import CloseCross from "../../assets/closeCross.svg"

export default function MyDatasets(props) {
    const navigation = useNavigate();
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer });
    const interfaceContainer = useSelector((store) => { return store.interfaceReducer });
    const dispatch = useDispatch();

    return <MyDatasetsClass
        {...props}
        navigation={navigation}
        dispatch={dispatch}
        datasetsContainer={datasetsContainer}
        interfaceContainer={interfaceContainer}
    />
}

var SORT_DATABASES = {
    date_91: "По дате",
    date_19: "По дате",
    name_91: "По имени",
    name_19: "По имени",
};

class MyDatasetsClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            myDatasets: null,
            allDatasets: null,
            datasetForDelete: null,
            filteringText: null,
            sortingValue: localStorage.getItem("sortingValue") ? localStorage.getItem("sortingValue") : 'date_91',
            forPublication: false
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        console.log("componentDidMount");

        //чтоб прелоадер показался
        this.startLoading();

        this.dataInterval = setInterval(() => {
            if (this.props.datasetsContainer.datasets) {
                this.setState({
                    allDatasets: this.props.datasetsContainer.datasets,
                }, () => {
                    if (this.state.filteringText !== null) {
                        this.filteringDatasets(this.state.filteringText)
                    }
                    else {
                        this.setState({
                            myDatasets: this.changeSorting(this.props.datasetsContainer.datasets)
                        })
                    }
                });
            }
        }, 100);
    }

    componentWillUnmount() {
        this.dataInterval && clearInterval(this.dataInterval)
    }

    filteringDatasets = (text) => {
        if (!this.state.allDatasets) {
            return;
        }
        let filtered = []
        this.state.allDatasets.forEach(dataset => {
            if (dataset.name.toLowerCase().includes(text.toLowerCase())) {
                filtered.push(dataset)
            }
        })
        this.setState({ filteringText: text, myDatasets: this.changeSorting(filtered) })
    }

    confirmDeleteDataset = (dataset) => {
        this.lkApi.deleteLKDataset(dataset.dataset).then((response) => {
            this.props.dispatch(updateMyDatasets());
        });
    }

    byField = (field) => {
        return (a, b) => a[field] > b[field] ? 1 : -1;
    }

    byFieldDown = (field) => {
        return (a, b) => a[field] > b[field] ? -1 : 1;
    }

    changeSorting = (datasets) => {
        let newDataset = datasets

        if (this.state.forPublication) {

            newDataset = []
            datasets.forEach((dataset, i) => {
                console.log(dataset)
                if (dataset.state && dataset.state.properties && dataset.state.properties.has_geometry) {
                    newDataset.push(dataset)
                }

            })
        }
        else {
            let filtered = []
            if (this.state.filteringText) this.state.allDatasets.forEach(dataset => {
                if (dataset.name.toLowerCase().includes(this.state.filteringText.toLowerCase())) {
                    filtered.push(dataset)
                }
            })
            else filtered = this.state.allDatasets

            newDataset = filtered
        }

        if (this.state.sortingValue) {
            if (this.state.sortingValue.split('_')[0] === 'name' && datasets) {

                if (this.state.sortingValue.split('_')[1] === '19') {
                    newDataset = datasets.sort(this.byField('name'))
                }
                else {
                    newDataset = datasets.sort(this.byFieldDown('name'))
                }
            }
            else {
                let emptyDate = []
                let withDate = []
                newDataset.forEach((dataset, i) => {
                    if (!dataset.dateOfCreating) {
                        if (dataset.create && dataset.create.time) {
                            dataset.dateCreate = dataset.create.time
                            withDate.push(dataset)
                        }
                        else emptyDate.push(dataset)
                    }
                })

                if (this.state.sortingValue.split('_')[1] === '19') {
                    newDataset = withDate.sort(this.byField('dateCreate'))
                }
                else {
                    newDataset = withDate.sort(this.byFieldDown('dateCreate'))
                }

                newDataset = [...withDate, ...emptyDate]
            }
        }

        return newDataset
    }

    updateDatasetState = (newDataset) => {
        this.setState({ myDatasets: newDataset })
    }


    render() {
        let myDatasets = this.state.myDatasets;

        if (myDatasets) {
            for (let i = 0; i < myDatasets.length; i++) {
                let history = [];
                if ((myDatasets[i].create && myDatasets[i].create.status)) {
                    history.push({ event: "создан", time: prettyDateTime(new Date(parseInt(myDatasets[i].create.time))) });
                }
                if ((myDatasets[i].import && myDatasets[i].import.status)) {
                    history.push({ event: "импортирован", time: prettyDateTime(new Date(parseInt(myDatasets[i].import.time))) });
                }
                if ((myDatasets[i].addGeometry && myDatasets[i].addGeometry.status)) {
                    history.push({ event: "оснащен геометрией", time: prettyDateTime(new Date(parseInt(myDatasets[i].addGeometry.time))) });
                }
                if ((myDatasets[i].addressDecomposed && myDatasets[i].addressDecomposed.status)) {
                    history.push({ event: "разобран адрес", time: prettyDateTime(new Date(parseInt(myDatasets[i].addressDecomposed.time))) });
                }
                if ((myDatasets[i].connect && myDatasets[i].connect.status)) {
                    history.push({ event: "связан", time: prettyDateTime(new Date(parseInt(myDatasets[i].connect.time))) });
                }
                if ((myDatasets[i].publicate && myDatasets[i].publicate.status)) {
                    history.push({ event: "опубликован", time: prettyDateTime(new Date(parseInt(myDatasets[i].publicate.time))) });
                }
                myDatasets[i].history = history;

                if (!myDatasets[i].fields) {
                    myDatasets[i].fields = [];
                }
                myDatasets[i].hasGeometry = (DatasetUtils.unsetGeometryFeatures(myDatasets[i].fields).length === 0);
                myDatasets[i].hasAddressParts = (DatasetUtils.unsetAddressFeatures(myDatasets[i].fields).length === 0);
                myDatasets[i].hasAllFeatures = (DatasetUtils.unsetConnectingByGeometryFeatures(myDatasets[i].fields).length === 0) || (DatasetUtils.unsetConnectingByAddressFeatures(myDatasets[i].fields).length === 0);
            }
        }


        let goToLeftPanel = (dataset, type) => {
            this.props.dispatch(selectDataset(dataset));
            this.props.dispatch(openLeftPanel(type));
        }

        let goToAnotherPage = (dataset, type) => {
            this.props.dispatch(selectDataset(dataset));
            this.goToSection(this.props.navigation, type);
        }

        //TODO: почему он здесь, а не внутри компонентов панелек?
        let exitCross = () => {
            return <img className='exitCross' src={CloseCross} onClick={() => {
                this.props.dispatch(openLeftPanel(null));
            }} alt='CloseCross' />
        }

        let getMainAction = (dataset) => {
            if (!dataset.state || !dataset.state.properties) {
                return {
                    label: this.sectionName(actionTypes.DATASET_TABLE),
                    action: () => { goToAnotherPage(dataset, "DatasetTable") }
                }
            }
            else {
                if (dataset.state.properties.connected) {
                    if (dataset.state.properties.published) {
                        if (dataset.state.properties.enriched) {
                            return {
                                label: "экспортировать", //специально отличается
                                action: () => { goToAnotherPage(dataset, "DatasetTable") }
                            }
                        }
                        else {
                            return {
                                label: "обогатить по ОАП", //специально отличается
                                action: () => { goToAnotherPage(dataset, "TuneMetadata") }
                            }
                        }
                    }
                    else {
                        return {
                            label: this.sectionName(actionTypes.PUBLISHER),
                            action: () => { goToLeftPanel(dataset, actionTypes.PUBLISHER) }
                        }
                    }
                }
                else {
                    if (dataset.state.properties.has_address_features || dataset.state.properties.has_address) {
                        return {
                            label: this.sectionName(actionTypes.CONNECTOR),
                            action: () => { goToLeftPanel(dataset, actionTypes.CONNECTOR) }
                        }
                        /*
                        return {
                            label: this.sectionName(actionTypes.DECOMPOSER),
                            action: () => { goToLeftPanel(dataset, actionTypes.DECOMPOSER) }
                        }
                        */
                    } else
                        if (dataset.state.properties.has_geometry) {
                            return {
                                label: this.sectionName(actionTypes.GEOMETRY_TRANSFORMER),
                                action: () => { goToLeftPanel(dataset, actionTypes.GEOMETRY_TRANSFORMER) }
                            }

                        }
                        else {
                            return {
                                label: "выбрать признаки", //специально отличается
                                action: () => { goToAnotherPage(dataset, "TuneMetadata") }
                            }

                        }
                }
            }
        }

        let leftPanel = this.props.interfaceContainer.leftPanel;

        return (<>
            {(leftPanel === actionTypes.CONNECTOR) && <Connector />}
            {(leftPanel === actionTypes.DECOMPOSER) && <Decomposer />}
            {(leftPanel === actionTypes.NORMALISER) && <Normaliser />}
            {(leftPanel === actionTypes.GEOMETRY_TRANSFORMER) && <GeometryTransformer />}
            {(leftPanel === actionTypes.PUBLISHER) && <Publisher />}
            {(leftPanel === actionTypes.IMPORT_DATASET) && <ImportDataset />}
            {(leftPanel === actionTypes.MY_TARIF) && <Tarifs />}
            {leftPanel && exitCross()}

            <div id="myDatasets" className="flexColumn rightPanel">
                {this.renderAlerts()}
                <div className="headerContainer">
                    <div className='titleContainer'><p className="headerMargin">Загруженные наборы</p>
                        <Button variant="primary" className="importMyDataDataset" onClick={() => { goToLeftPanel(null, actionTypes.IMPORT_DATASET) }}>{this.sectionName(actionTypes.IMPORT_DATASET)}</Button>
                    </div>
                    <div className='inputContainer'><input id='inputContainerDatasets' className='inputStyle textRoboto' placeholder="Найти..." onChange={e => this.filteringDatasets(e.target.value)} /><div className='nopeFiltering' onClick={e => {
                        this.filteringDatasets('')
                        let input = document.getElementById('inputContainerDatasets')
                        if (input && input.value) input.value = ''
                    }
                    }><img className='filter-icon' src={CloseCross} alt='find icon' /></div>
                    </div>
                </div>
                <div className="postHeaderContainer textRoboto">
                    <p>Сортировать:</p>
                    <Dropdown className="sortButton">
                        <Dropdown.Toggle className="dropdownButtonSort textRoboto" variant="success" id="dropdown-basic">
                            <p>{this.state.sortingValue ? SORT_DATABASES[this.state.sortingValue] : "Выберите тип сортировки"}</p>
                            <img className={this.state.sortingValue.split('_')[1] === '19' ? 'dropArrow' : 'dropArrow downMirrow'} src={Filter_A_Z} alt='dropArrow' />
                            <img className='dropArrow' src={Arrow} alt='dropArrow' />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {Object.entries(SORT_DATABASES).map((typeArray, index) => (
                                <Dropdown.Item key={index} onClick={() => {
                                    this.setState({ sortingValue: typeArray[0] }, () => { this.updateDatasetState(this.changeSorting(this.state.myDatasets)) });
                                }}>
                                    {typeArray[1]}
                                    <img className={typeArray[0].split('_')[1] === '19' ? 'dropArrow' : 'dropArrow downMirrow'} src={Filter_A_Z} alt='dropArrow' />
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                    <input type="checkbox" id="switch" onChange={(e) => {
                        this.setState({ forPublication: e.target.checked },
                            () => { this.updateDatasetState(this.changeSorting(this.state.myDatasets)) })
                    }} />
                    <label htmlFor="switch" id='switchLabel'>Toggle</label>
                    <p>Только «Готовые для публикации»</p>
                </div>

                <Container className="containerListStyle">
                    {this.state.myDatasets ?
                        (
                            this.state.myDatasets.length > 0 ? this.state.myDatasets.map((dataset) => {
                                let buttonsList = this.getPropertiesForButtonsList(dataset);
                                let operations = this.getOperationsList();

                                let importRunning = checkActiveProcess(dataset, 'lk_importer') || { lastInfo: { progress: 0.99 } };

                                return <div key={dataset._id} className={"inMyDataBlocks"}>
                                    <div className='dataset-name-line'>
                                        <div className={'datasetMyDataName'}>
                                            {dataset.name}
                                        </div>
                                        <Dropdown className="">
                                            <Dropdown.Toggle className="delButton textRoboto" variant="success" id="dropdown-basic">
                                                <img className='dataset-info-icon cursor-pointer' src={MenuIcon} onClick={() => console.log('open menu')} alt='MenuIcon' />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item className='delItem' onClick={() => {
                                                    this.confirmDeleteDataset(dataset)
                                                }}>
                                                    Удалить
                                                </Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className='dataset-info-lines'>
                                        {dataset.history && (dataset.history.length > 0) &&
                                            <div className='dataset-info-dataline'>
                                                <img className='dataset-info-icon' src={DataIcon} alt='dataicon' />
                                                <p className='dataset-info-dataline-p'>{dataset.history[0].event}: {dataset.history[0].time}</p>
                                            </div>
                                        }

                                        <div className='dataset-info-infoline'>
                                            {operations.map((operation, index) => {
                                                if (((operation.field === 'any') && (!buttonsList.nothing)) || ((operation.field !== 'any') && (buttonsList[operation.field]))) {
                                                    return <div key={'dataset-info-infoline-line' + index} className='dataset-info-infoline-line cursor-pointer' onClick={() => {
                                                        if (operation.anotherPage) {
                                                            goToAnotherPage(dataset, operation.anotherPage);
                                                        } else {
                                                            goToLeftPanel(dataset, operation.type)
                                                        }
                                                    }}>
                                                        <img className='dataset-info-icon' src={this.sectionIcon(operation.type)} alt='' />
                                                        <p className='dataset-info-infoline-p'>{this.sectionName(operation.type)}</p>
                                                        {buttonsList[operation.field + 'Notify'] &&
                                                            <img className='dataset-info-notify' src={buttonsList[operation.field + 'Notify']} alt='notify' />
                                                        }
                                                    </div>
                                                }
                                            })}

                                            {buttonsList.nothing &&
                                                <div className='dataset-info-infoline-line' onClick={() => { }}>
                                                    {dataset.database &&
                                                        <p className='dataset-info-dataline-cursive'>Это общедоступный набор данных, вы можете смотреть его, делать выборки и скачивать.</p>
                                                    }
                                                    {!dataset.database &&
                                                        <p className='dataset-info-dataline-cursive'>
                                                            Набор недавно загружен и еще готовится.<br />
                                                            {'Прогресс - ' + Math.round(importRunning.lastInfo.progress * 100) + '%'}<br />
                                                            Скоро он станет доступен для обработки, пока что можете только смотреть.
                                                        </p>
                                                    }
                                                </div>
                                            }

                                        </div>
                                    </div>

                                    <div className='dataset-info-footer' onClick={getMainAction(dataset).action}>
                                        <div className='dataset-info-footer-button cursor-pointer'>
                                            <p className='dataset-info-footer-button-p'>{getMainAction(dataset).label}</p>
                                        </div>
                                    </div>
                                </div>
                            })
                                :
                                <div className={"inMyDataBlocks"}>
                                    <div className='dataset-name-line'>
                                    </div>
                                    <div className='dataset-info-infoline'>
                                        <div className='dataset-info-lines'>

                                            <div className='dataset-info-infoline-line' onClick={() => { }}>
                                                <p className='dataset-info-dataline-cursive'>
                                                    {this.state.allDatasets && (this.state.allDatasets.length > 0) ?
                                                        'У вас нет датасетов с названием, похожим на «' + this.state.filteringText + '»' :
                                                        'Создайте свой первый набор данных. Принимаются форматы Excel и GeoJSON.'}
                                                </p>
                                            </div>
                                            <Button variant="primary" className="importMyDataDataset bigImportButton" onClick={() => { goToLeftPanel(null, actionTypes.IMPORT_DATASET) }}>Добавить файл</Button>
                                        </div>
                                    </div>
                                </div>
                        )
                        :
                        this.renderPreloader()
                    }
                </Container>
                {this.state.message}
            </div ></>
        );
    }
}